import React, {type ReactNode, type JSX} from 'react';
import {styled} from '@mui/material/styles';

type Props = {
  handleClick: () => void;
  isSelected?: boolean;
  children: ReactNode;
  testId?: string;
};

const StyledButton = styled('button')<{isSelected: boolean}>(
  ({theme, isSelected}) => ({
    border: isSelected
      ? `1px solid ${theme.palette.secondary.main}`
      : `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    borderRadius: `${theme.shape.borderRadius}px`,
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(1),

    '&:hover': {
      border: `1px solid ${theme.palette.secondary.main}`,
      backgroundColor: `${theme.palette.action.hover}`,
      cursor: 'pointer',
    },

    '&:hover .title': {
      color: theme.palette.secondary.main,
    },
  })
);

export function CustomizedCard({
  isSelected = false,
  testId,
  handleClick,
  children,
}: Readonly<Props>): JSX.Element {
  return (
    <StyledButton
      type="button"
      tabIndex={0}
      isSelected={isSelected}
      onKeyDown={handleClick}
      onClick={handleClick}
      data-testid={testId ?? null}
    >
      {children}
    </StyledButton>
  );
}
